import React from "react";
import { css } from "@emotion/react";
import { FieldLabel } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { requiredNameValidation } from "@/components/validations";
import { FormErrorMessage, FormTextField } from "@/components/molecules";

type Props = {
  nameLastName: string;
  nameFirstName: string;
};

const nameFormField = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();

  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <FieldLabel isRequired>氏名</FieldLabel>
      </div>
      <div css={inputWrapper}>
        <div css={textFieldWrapper}>
          <FormTextField
            name={props.nameLastName}
            placeholder="例) 田中"
            registerOptions={{
              validate: requiredNameValidation,
            }}
            ref={ref}
            css={textField}
          />
          <FormErrorMessage name={props.nameLastName} css={errorField} />
        </div>

        <div css={textFieldWrapper}>
          <FormTextField
            name={props.nameFirstName}
            placeholder="例) 太郎"
            registerOptions={{
              validate: requiredNameValidation,
            }}
            ref={ref}
            css={textField}
          />
          <FormErrorMessage name={props.nameFirstName} css={errorField} />
        </div>
      </div>
    </div>
  );
};

export const NameFormField = React.forwardRef(nameFormField);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const textField = css({
  display: "inline-block",
});

const textFieldWrapper = css({
  width: "49%",
});

const inputWrapper = css({
  width: "100%",
  display: "flex",
  flex: 1,
  justifyContent: "space-between",
});

const errorField = css({
  display: "inline-block",
});
